export type EventReturnPath = "/" | "/board";

export interface EventReturnNavigation {
  path: EventReturnPath;
  label: "カタログに戻る" | "リストに戻る";
  useHistory: boolean;
}

let previousPath: string | undefined;
let lastCatalogOrListPath: EventReturnPath | undefined;

export function resolveEventReturnNavigation(
  previousPath: string | undefined,
  lastCatalogOrListPath: string | undefined,
  basePath = "",
): EventReturnNavigation {
  const normalizedPreviousPath = normalizePath(previousPath, basePath);
  const normalizedLastCatalogOrListPath = normalizePath(
    lastCatalogOrListPath,
    basePath,
  );
  const path =
    asCatalogOrListPath(normalizedPreviousPath) ??
    asCatalogOrListPath(normalizedLastCatalogOrListPath) ??
    "/";

  return {
    path,
    label: path === "/board" ? "リストに戻る" : "カタログに戻る",
    useHistory: normalizedPreviousPath === path,
  };
}

export function recordEventReturnNavigation(
  fromPath: string | undefined,
  toPath: string,
  basePath = "",
): void {
  const normalizedFromPath = normalizePath(fromPath, basePath);
  const normalizedToPath = normalizePath(toPath, basePath);
  if (normalizedFromPath === normalizedToPath) return;
  const fromCatalogOrListPath = asCatalogOrListPath(normalizedFromPath);
  const toCatalogOrListPath = asCatalogOrListPath(normalizedToPath);

  if (toCatalogOrListPath) {
    lastCatalogOrListPath = toCatalogOrListPath;
  } else if (fromCatalogOrListPath) {
    lastCatalogOrListPath = fromCatalogOrListPath;
  }
  previousPath = normalizedFromPath;
}

export function getEventReturnNavigation(basePath = ""): EventReturnNavigation {
  return resolveEventReturnNavigation(
    previousPath,
    lastCatalogOrListPath,
    basePath,
  );
}

function normalizePath(
  pathname: string | undefined,
  basePath: string,
): string | undefined {
  if (pathname === undefined) return undefined;
  const normalizedBasePath = basePath.replace(/\/+$/u, "");
  let normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
  if (
    normalizedBasePath !== "" &&
    normalizedBasePath !== "/" &&
    (normalizedPath === normalizedBasePath ||
      normalizedPath.startsWith(`${normalizedBasePath}/`))
  ) {
    normalizedPath = normalizedPath.slice(normalizedBasePath.length) || "/";
  }
  return normalizedPath.replace(/\/+$/u, "") || "/";
}

function asCatalogOrListPath(
  pathname: string | undefined,
): EventReturnPath | undefined {
  if (pathname === "/" || pathname === "/board") return pathname;
  return undefined;
}
